<div class="container">
    <div class="text">How was your last order from Italian Food Court</div>
    <div class="orderid">Order Id: {{data.orderNum}} </div>
    <div class="rating">
        <div class="emojis" *ngFor="let item of items; let i=index" (click)="onClick(i)" [ngClass]="{'active-item' : item.active}">
            <img [src]="item.img">
        </div>
    </div>
</div>